export enum TypesCRM {
  MATRICULA = 1,
  REMATRICULA = 2,
  INADIMPLENCIA = 3,
}
